import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from 'react-router-dom';
import { RoleProvider } from './contexts/RoleContext';
import { SseProvider } from './components/sseProvider/sseProvider';
import { API_ENDPOINT } from './config/apiEndpoint';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
     <RoleProvider>
      <SseProvider API_ENDPOINT={API_ENDPOINT}>
        <App />
      </SseProvider>
      
      
      </RoleProvider>
    </BrowserRouter>

  </React.StrictMode>
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
